import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { routeConfigs } from 'src/app/common/constants/route.config';
import { VisitorCalendarComponent } from '../shared/components/visitor/visitor.calendar/visitor.calendar.component';
import { VisitorPlaceMapComponent } from './components/visitor.place.map/visitor.place.map.component';
import { OneRowWidgetComponent } from '../shared/components/visitor/one.row.widget/one.row.widget.component';
import { FancyPlaceDetailsModalComponent } from './components/place.details.modal/fancy.place.details.modal/fancy.place.details.modal.component';

const routes: Routes = [
  {
    path: '',
    component: VisitorCalendarComponent,
    children: [
      {
        path: routeConfigs.visitor.placeCalendar.category.path,
        component: VisitorCalendarComponent,
      },
      {
        path: routeConfigs.visitor.placeCalendar.favCustomPlace.path,
        component: VisitorCalendarComponent,
      },
      {
        path: routeConfigs.visitor.placeCalendar.customDefaultPlace.path,
        component: VisitorCalendarComponent,
      },
      {
        // submit place page is a popup modal, so it should be a child of place calendar
        path: routeConfigs.visitor.placeCalendar.createPlace.path,
        component: VisitorCalendarComponent,
      },
      {
        path: routeConfigs.visitor.placeCalendar.editorChoice.path,
        component: VisitorCalendarComponent,
      },
      {
        path: routeConfigs.visitor.placeCalendar.placeDetailsModal.path,
        component: VisitorCalendarComponent,
      },
      {
        path: routeConfigs.visitor.placeCalendar.locationFilter.path,
        component: VisitorCalendarComponent,
      },
      {
        path: routeConfigs.visitor.placeCalendar.groupLocationFilter.path,
        component: VisitorCalendarComponent,
      },
      // {
      //   path: routeConfigs.visitor.placeCalendar.placeDetails.path,
      //   component: FancyPlaceDetailsModalComponent,
      // },
    ],
  },
  {
    path: routeConfigs.visitor.placeCalendar.placeDetailsForEmbedding.path,
    component: FancyPlaceDetailsModalComponent,
  },
  {
    path: routeConfigs.visitor.placeCalendar.placeMapAll.path,
    component: VisitorPlaceMapComponent,
  },
  {
    path: routeConfigs.visitor.placeCalendar.placeMap.path,
    component: VisitorPlaceMapComponent,
  },
  {
    path: routeConfigs.visitor.placeCalendar.oneRow.path,
    component: OneRowWidgetComponent,
  },
  {
    path: routeConfigs.visitor.placeCalendar.editorChoiceOneRow.path,
    component: OneRowWidgetComponent,
  },
  {
    path: routeConfigs.visitor.placeCalendar.favCustomPlaceOneRow.path,
    component: OneRowWidgetComponent,
  },
  {
    path: routeConfigs.visitor.placeCalendar.customDefaultPlaceOneRow.path,
    component: OneRowWidgetComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PlaceCalendarRoutingModule {
}
